import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, description, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4">
      <div>
        {eyebrow && (
          <p className="flex items-center gap-2 font-label text-[11px] font-semibold uppercase tracking-[0.2em] text-primary-600">
            <span className="h-1 w-6 rounded-full bg-accent-500"></span>
            {eyebrow}
          </p>
        )}
        <h2 className="mt-2 font-heading text-xl font-extrabold tracking-tight text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {description && (
          <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-foreground-500">{description}</p>
        )}
      </div>
      {action}
    </div>
  );
}